import { useEffect, useState } from "react";
import { Monitor, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { addTerminal, getCurrent, getTerminals } from "@/lib/terminals";

const dmy = (d) => d.split("-").reverse().join("/");

export default function TerminalPicker({ open, onClose, onOpen }) {
  const { t, view } = useApp();
  const [list, setList] = useState(getTerminals);
  const [selId, setSelId] = useState(() => getCurrent()?.id || getTerminals()[0]?.id);
  const [name, setName] = useState("");
  useEffect(() => { if (open) setList(getTerminals()); }, [open]);
  const add = () => {
    const n = name.trim().toUpperCase();
    if (!n) return;
    const l = addTerminal(n, n);
    setList(l); setSelId(l[l.length - 1].id); setName("");
  };
  const th = "px-2 py-1.5 font-normal text-start border-b border-[#D5DCE6]";
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl p-0 gap-0 rounded-none border-[#9AA9BC] bg-white" data-testid="terminal-picker">
        <DialogTitle className="px-3 py-2 text-xs font-normal text-[#7A8797] border-b border-[#E3E8EF]">{t("tm_open_terminals")} · {view.shop?.name}</DialogTitle>
        <div className="flex items-center gap-2 px-3 py-2 text-sm text-[#333]"><Monitor className="w-5 h-5 text-[#3A6EA5]" />{t("tm_terminal")}</div>
        <div className="min-h-[220px] max-h-[50vh] overflow-auto border-y border-[#E3E8EF]">
          <table className="w-full text-[12px] text-[#333]">
            <thead className="bg-[#F3F5F8]"><tr><th className={`${th} w-6`} /><th className={th}>{t("tm_terminal")}</th><th className={th}>{t("tm_date")}</th><th className={th}>{t("tm_store")}</th><th className={th}>{t("tm_pos")}</th></tr></thead>
            <tbody>
              {list.map((x, i) => (
                <tr key={x.id} onClick={() => setSelId(x.id)} onDoubleClick={() => onOpen(x.id)} data-testid="terminal-picker-row"
                  className={`cursor-pointer border-b border-[#EEF1F5] ${x.id === selId ? "bg-[#FBDDA8]" : "hover:bg-[#F3F7FC]"}`}>
                  <td className="px-2 py-1.5 text-[10px] text-[#8A96A6]">{i + 1}</td>
                  <td className="px-2 py-1.5">{x.name}</td><td className="px-2 py-1.5" dir="ltr">{dmy(x.date)}</td>
                  <td className="px-2 py-1.5">{view.shop?.name}</td><td className="px-2 py-1.5">{x.pos}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-wrap gap-2 p-3">
          <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder={t("tm_add")}
            className="flex-1 min-w-[140px] h-10 border border-[#C9D3E0] px-2 text-sm" data-testid="terminal-picker-name" />
          <button type="button" onClick={add} className="h-10 px-3 border border-[#B4C4D8] bg-[#DCE6F2] text-xs font-bold uppercase flex items-center gap-1" data-testid="terminal-picker-add"><Plus className="w-4 h-4" />{t("tm_add")}</button>
          <button type="button" onClick={() => selId && onOpen(selId)} className="h-10 px-5 bg-[#3A6EA5] text-white text-xs font-bold uppercase" data-testid="terminal-picker-open">{t("tm_open")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
